import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ScrollToTop, NotFoundPage } from './components/common';
import { LandingLayout } from './layouts';
import { publicLandingRoutes } from './utils/routes';

type Props = {};

const App = (props: Props) => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Landing Routes */}
        <Route element={<LandingLayout />}>
          {publicLandingRoutes.map((route, index) => {
            const Page = route.component || '';
            return <Route key={index} path={route.path} element={<Page />} />;
          })}
        </Route>

        {/* 404 - Not Found */}
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
